import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner'
import {ActivatedRoute} from '@angular/router'
import { Location } from '@angular/common';
import { CadastroEleicaoComponent } from 'src/app/pages/gestor/cadastro-eleicao/cadastro-eleicao.component'

@Component({
  selector: 'app-parametrizacoes-email',
  templateUrl: './parametrizacoesEmail.component.html',
  styleUrls: ['./parametrizacoesEmail.component.css']
})
export class ParametrizacoesEmailComponent implements OnInit {
  eleicaoParametrizacao: any;
  temIntegracao: any;
  enviaEmails: any;

  constructor(
    public spinner: NgxSpinnerService,
    public router: ActivatedRoute,
    private location: Location,
    private eleCad: CadastroEleicaoComponent,
  ) { }

  ngOnInit() {
    this.spinner.show();
    this.eleicaoParametrizacao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao"));
    if(this.eleicaoParametrizacao.acessoIntegracao != "false"){
      this.temIntegracao = true;
      sessionStorage.setItem("temIntegracao", this.temIntegracao);
    }
    if(this.eleicaoParametrizacao.enviaEmails != "false"){
      this.enviaEmails = true;
      sessionStorage.setItem("enviaEmails", this.enviaEmails);
    }
    this.spinner.hide();
  }
  voltar(){
    sessionStorage.removeItem("eleicaoClicadaParametrizacao");
    this.location.back();
  }
}
